export default {
    approvals: {
        title: "Aprovação",
        error: "Ocorreu um erro"
    },
    delegates: {
        title: "Delegados",
        error: "Ocorreu um erro",
        noDelegates: "Nenhum item",
        delegateDelete: "O delegado foi excluído",
        confirm: {
            delete: "Excluir delegado?"
        },
        delegates: {
            email: "E-mail",
            startDate: "Data de início",
            endDate: "Data de término",
        },
        buttons: {
            add: {
                text: "Adicionar Delegado"
            }
        }
    },
    employees: {
        title: "Meus funcionários",
        error: "Ocorreu um erro",
        empty: "Nenhum funcionário encontrado",
        users: {
            name: "Nome",
            email: "E-mail"
        },
        model: {
            search: {
                placeholder: "Procurar",
            }
        },
        cta: {
            orders: "Ordens de carga",
            download: "Pedidos de download",
            search: "Procurar"
        }
    }
}